import React from "react";

import { observer } from "mobx-react";
import LmtLsEventStore from "@state/stores/side-widgets/LmtLsEventStore";
import { EventOffer } from "@gp/offer";

import { EventRow } from ".";

type TEventListTabs = "LMT" | "LS";

export const EventList = observer(
	(props: { lmtLsStore: LmtLsEventStore; tab: TEventListTabs }) => {
		let events: EventOffer[] = [];
		if (props.tab === "LMT") {
			events = props.lmtLsStore.lmtEvents;
		} else if (props.tab === "LS") {
			events = props.lmtLsStore.lsEvents;
		}

		return (
			<div className="widget__list">
				{events.map((e) => (
					<EventRow
						key={e.id}
						lmtLsStore={props.lmtLsStore}
						event={e as EventOffer}
						tab={props.tab}
					/>
				))}
			</div>
		);
	}
);
